
import { 
    Block,
    Build,
    CancelOutlined,
    Check,
    CheckCircleOutline,
    Close,
    ContentPasteSearch,
    DoDisturbOn,
    EventBusy,
    HelpOutline,
    LockOpenOutlined,
    LockOutlined,
    Login,
    Logout, 
    Person, 
    RemoveCircleOutline, 
    Schedule, 
    Star 
} from "@mui/icons-material";
import { IMuiIcon } from "../interfaces/IMaterial";




// Http Status
export enum HttpStatusEnum {
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    NotAcceptable = 406,
    Conflict = 409,
    PreconditionFailed = 412,
    UnsupportedMediaType = 415,
    InternalServerError = 500
}





// Registration Status
export enum RegistrationStatusEnum {
    Empty = 0,
    Actived = 1,
    Inactived = 2,
    Excluded = 3
}

interface IRegistrationStatusData {
    id: number;
    name: string;
    Icon: IMuiIcon;
    className: string;
    visible: boolean;
}

export const RegistrationStatusData: Record<RegistrationStatusEnum, IRegistrationStatusData> = {
    [RegistrationStatusEnum.Empty]: {
        id: RegistrationStatusEnum.Empty,
        name: 'empty',
        Icon: HelpOutline,
        className: 'color-empty',
        visible: false
    },
    [RegistrationStatusEnum.Actived]: {
        id: RegistrationStatusEnum.Actived,
        name: 'actived',
        Icon: CheckCircleOutline,
        className: 'color-actived',
        visible: true
    },
    [RegistrationStatusEnum.Inactived]: {
        id: RegistrationStatusEnum.Inactived,
        name: 'inactived',
        Icon: RemoveCircleOutline,
        className: 'color-inactived',
        visible: true
    },
    [RegistrationStatusEnum.Excluded]: {
        id: RegistrationStatusEnum.Excluded,
        name: 'excluded',
        Icon: CancelOutlined,
        className: 'color-excluded',
        visible: true
    }
}





// Default interface for status
export interface IDefaultStatusData {
    key: number;
    name: string;
    color: string;
    Icon: IMuiIcon;
    partnerId?: string | undefined;
}





// Occupancy Status
export enum OccupancyStatusEnum {
    Available = 1,
    Occupied = 2
}

export const OccupancyStatusData: Record<OccupancyStatusEnum, IDefaultStatusData> = {
    [OccupancyStatusEnum.Available]: {
        key: OccupancyStatusEnum.Available,
        name: 'available',
        color: '#43a047',
        Icon: LockOpenOutlined,
        partnerId: undefined
    },
    [OccupancyStatusEnum.Occupied]: {
        key: OccupancyStatusEnum.Occupied,
        name: 'occupied',
        color: '#d32f2f',
        Icon: LockOutlined,
        partnerId: undefined
    }
}





// Room Status
export enum RoomStatusEnum {
    RoomBlocking = 1,
    OwnerReservation = 2,
    VipReservation = 3,
    DoNotDisturb = 4,
    ExpectedCheckIn = 5,
    ExpectedCheckOut = 6
}

export const RoomStatusData: Record<RoomStatusEnum, IDefaultStatusData> = {
    [RoomStatusEnum.RoomBlocking]: {
        key: RoomStatusEnum.RoomBlocking,
        name: 'blocked',
        color: '#263238',
        Icon: EventBusy,
        partnerId: 'blocked'
    },
    [RoomStatusEnum.OwnerReservation]: {
        key: RoomStatusEnum.OwnerReservation,
        name: 'ownerReservation',
        color: '#37474f',
        Icon: Person,
        partnerId: 'ownerGuestType'
    },
    [RoomStatusEnum.VipReservation]: {
        key: RoomStatusEnum.VipReservation,
        name: 'vipReservation',
        color: '#f9a825',
        Icon: Star,
        partnerId: 'vipGuestType'
    },
    [RoomStatusEnum.DoNotDisturb]: {
        key: RoomStatusEnum.DoNotDisturb,
        name: 'doNotDisturb',
        color: '#283593',
        Icon: DoDisturbOn,
        partnerId: 'doNotDisturb'
    },
    [RoomStatusEnum.ExpectedCheckIn]: {
        key: RoomStatusEnum.ExpectedCheckIn,
        name: 'expectedCheckIn',
        color: '#ff8f00',
        Icon: Login,
        partnerId: 'expectedCheckIn'
    },
    [RoomStatusEnum.ExpectedCheckOut]: {
        key: RoomStatusEnum.ExpectedCheckOut,
        name: 'expectedCheckOut',
        color: '#e53935',
        Icon: Logout,
        partnerId: 'expectedCheckOut'
    }
}





// Governance Status
export enum GovernanceStatusEnum {
    Clean = 1,
    Dirty = 2,
    Inspection = 3,
    InTidying = 4,
    Maintenance = 5,
    Interdicted = 6
}

export const GovernanceStatusData: Record<GovernanceStatusEnum, IDefaultStatusData> = {
    [GovernanceStatusEnum.Clean]: {
        key: GovernanceStatusEnum.Clean,
        name: 'clean',
        color: '#4caf50',
        Icon: Check,
        partnerId: undefined
    },
    [GovernanceStatusEnum.Dirty]: {
        key: GovernanceStatusEnum.Dirty,
        name: 'dirty',
        color: '#e53935',
        Icon: Close,
        partnerId: undefined
    },
    [GovernanceStatusEnum.Inspection]: {
        key: GovernanceStatusEnum.Inspection,
        name: 'inspection',
        color: '#156BAF',
        Icon: ContentPasteSearch,
        partnerId: undefined
    },
    [GovernanceStatusEnum.InTidying]: {
        key: GovernanceStatusEnum.InTidying,
        name: 'inTidying',
        color: '#ffa000',
        Icon: Schedule,
        partnerId: undefined
    },
    [GovernanceStatusEnum.Maintenance]: {
        key: GovernanceStatusEnum.Maintenance,
        name: 'maintenance',
        color: '#6d4c41',
        Icon: Build,
        partnerId: undefined
    },
    [GovernanceStatusEnum.Interdicted]: {
        key: GovernanceStatusEnum.Interdicted,
        name: 'interdicted',
        color: '#37474f',
        Icon: Block,
        partnerId: undefined
    }
}
